import { render, staticRenderFns } from "./ListaDePagamentosEletronicos.vue?vue&type=template&id=56b1bd90&scoped=true"
import script from "./ListaDePagamentosEletronicos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaDePagamentosEletronicos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListaDePagamentosEletronicos.vue?vue&type=style&index=0&id=56b1bd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1bd90",
  null
  
)

export default component.exports